// extracted by mini-css-extract-plugin
export default {"reason_card":"ManageAlertModal-module_reason_card_mJGlNH","reason_card_selected":"ManageAlertModal-module_reason_card_selected_bIEzgq"};